import { literals } from "@/constants/literals";
import Textarea from "@/components/textarea/Textarea";
import InputCheckbox from "@/components/input-checkbox/InputCheckbox";
import InputSelect from "@/components/input-select/InputSelect";
import { PACKAGING_STEP_DESCRIPTION_OPTIONS } from "@/constants/selectsLists";
import type { GroupData, ExitsStep } from "@/types/types.d";

type ExitsGroupTabletInputsProps = {
  groupData: GroupData;
  step: ExitsStep;
  description: string;
  extraInformation: string;
  changeGroupData: (id: string, value: string | boolean) => void;
  changeDescription: (value: string) => void;
  changeExtraInformation: (value: string) => void;
};

const ExitsGroupTabletInputs = ({
  step,
  groupData,
  description,
  extraInformation,
  changeGroupData,
  changeDescription,
  changeExtraInformation,
}: ExitsGroupTabletInputsProps) => {
  return (
    <div className="w-full my-4" data-testid="no-mobile-inputs">
      <div className="flex flex-row gap-x-4 mb-4 items-end">
        {step === literals.packagingAction ? (
          <div className="w-[calc((100%-30px)/4)] lg:w-[calc((100%-40px)/5)] min-w-[200px] mb-4">
            <InputSelect
              size="medium"
              label={literals.description}
              id="description"
              name="description"
              options={PACKAGING_STEP_DESCRIPTION_OPTIONS}
              onChange={changeDescription}
              value={description}
              required
              placeholder={literals.chooseAnOption}
            />
          </div>
        ) : null}
        <div
          className={`${step === literals.packagingAction ? "h-[38px]" : ""}`}
        >
          <InputCheckbox
            title={literals.visibleForClients}
            onChange={(new_value) =>
              changeGroupData("visibleForClient", new_value)
            }
            checked={groupData.visibleForClient}
            id="visibleForClient"
          />
        </div>
      </div>
      {step === literals.packagingAction ? (
        <Textarea
          label={literals.extraInformation}
          onChange={changeExtraInformation}
          name="extrainformation"
          value={extraInformation}
          deleteMessage={literals.cleanExtrainfo}
          size="medium"
          rows={1}
        />
      ) : (
        <Textarea
          label={literals.description}
          onChange={(description) =>
            changeGroupData("description", description)
          }
          name="description"
          value={groupData.description}
          deleteMessage={literals.cleanDescription}
          size="medium"
          rows={1}
        />
      )}
    </div>
  );
};

export default ExitsGroupTabletInputs;
